var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-typeahead-bootstrap',{attrs:{"data":_vm.customers,"serializer":s =>
            `${s.name} ${s.email ? ' --Email:' + s.email : ''}  ${
                s.phone ? ' --Phone:' + s.phone : ''
            }`,"placeholder":"Customer Search...","disabled":_vm.disabled,"backgroundVariant":"list-group-item list-group-item-light"},on:{"hit":_vm.getCustomer,"input":_vm.lookupCustomers},model:{value:(_vm.searchedCustomer),callback:function ($$v) {_vm.searchedCustomer=$$v},expression:"searchedCustomer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }